import React from "react";
import { withRedux, displayError, SecureLocalStorage } from "helpers";

const joyRideCacheArray = [
  "rewards",
  "deals",
  "aboutUs",
  "titleText",
  "imageTitleText",
  "pictureCatalog",
  "website",
  "punchCard",
  "businessCreation",
  "home",
];

const getTouredByArray = (tours) => {
  const toured = {};

  tours.forEach((tour) => {
    const cache = localStorage.getItem(`${tour}-toured`);
    toured[tour] = cache || false;
  });

  return toured;
};

const setTouredArray = (tours) => {
  for (let tour in tours) {
    localStorage.setItem(`${tour}-toured`, tours[tour]);
  }
};

function ClearStorage({ actions: { logOut } }) {
  // console.log("clearing storage");
  const isE = localStorage.getItem("isE");
  const chimpSub = localStorage.getItem("chimpSub");
  const root = localStorage.getItem("persist:root");
  const execute = () => {
    logOut();
    const joyRideCache = getTouredByArray(joyRideCacheArray);
    localStorage.clear();
    // sessionStorage.clear();

    // don't clear these caches
    localStorage.setItem("isE", isE);
    localStorage.setItem("chimpSub", chimpSub);
    setTouredArray(joyRideCache);
  };

  if (!isE && root) execute();
  return null;
}

export default withRedux(ClearStorage);
